import { type ClassValue, clsx } from "clsx";
import { intervalToDuration } from "date-fns";
import { twMerge } from "tailwind-merge";
import { env } from "~/env";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDuration(durationInSeconds: number): string {
  if (typeof durationInSeconds !== "number" || isNaN(durationInSeconds)) {
    return "0:00";
  }

  const duration = intervalToDuration({
    start: 0,
    end: Math.max(0, durationInSeconds),
  });

  const hours = duration.hours ?? 0;
  const minutes = duration.minutes ?? 0;
  const seconds = duration.seconds ?? 0;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function getBaseUrl() {
  if (typeof window !== "undefined") {
    // browser should use relative path
    return "";
  }
  if (env.VERCEL_PROJECT_PRODUCTION_URL) {
    // reference for vercel.com
    return `https://${env.VERCEL_PROJECT_PRODUCTION_URL}`;
  }
  // assume localhost
  return `http://localhost:${process.env.PORT ?? 3000}`;
}

export function isEmpty<T>(value: T[] | null | undefined): boolean {
  return !value || value.length < 1;
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const truncateTitle = (title: string, maxLength = 50) => {
  if (title.length <= maxLength) return title;
  return `${title.slice(0, maxLength)}...`;
};
